// Curated set of dialing codes for the country-code picker in PhoneInput —
// not exhaustive (200+ countries would make the dropdown unwieldy), but
// covers Nigeria (default, since this is a Naira-denominated product),
// the rest of the markets referenced on the marketing site ("Lagos to
// Kaduna... investors across Nigeria" plus broader African/diaspora
// reach), and the world's other major markets.
export const COUNTRY_PHONE_CODES = [
  { name: 'Nigeria', iso2: 'NG', dial: '+234', flag: '🇳🇬' },
  { name: 'Ghana', iso2: 'GH', dial: '+233', flag: '🇬🇭' },
  { name: 'Kenya', iso2: 'KE', dial: '+254', flag: '🇰🇪' },
  { name: 'South Africa', iso2: 'ZA', dial: '+27', flag: '🇿🇦' },
  { name: 'Egypt', iso2: 'EG', dial: '+20', flag: '🇪🇬' },
  { name: 'Morocco', iso2: 'MA', dial: '+212', flag: '🇲🇦' },
  { name: 'Ethiopia', iso2: 'ET', dial: '+251', flag: '🇪🇹' },
  { name: 'Tanzania', iso2: 'TZ', dial: '+255', flag: '🇹🇿' },
  { name: 'Uganda', iso2: 'UG', dial: '+256', flag: '🇺🇬' },
  { name: 'Rwanda', iso2: 'RW', dial: '+250', flag: '🇷🇼' },
  { name: 'Senegal', iso2: 'SN', dial: '+221', flag: '🇸🇳' },
  { name: "Côte d'Ivoire", iso2: 'CI', dial: '+225', flag: '🇨🇮' },
  { name: 'Cameroon', iso2: 'CM', dial: '+237', flag: '🇨🇲' },
  { name: 'Zambia', iso2: 'ZM', dial: '+260', flag: '🇿🇲' },
  { name: 'Zimbabwe', iso2: 'ZW', dial: '+263', flag: '🇿🇼' },
  { name: 'United Kingdom', iso2: 'GB', dial: '+44', flag: '🇬🇧' },
  { name: 'Ireland', iso2: 'IE', dial: '+353', flag: '🇮🇪' },
  { name: 'United States', iso2: 'US', dial: '+1', flag: '🇺🇸' },
  { name: 'Canada', iso2: 'CA', dial: '+1', flag: '🇨🇦' },
  { name: 'Germany', iso2: 'DE', dial: '+49', flag: '🇩🇪' },
  { name: 'France', iso2: 'FR', dial: '+33', flag: '🇫🇷' },
  { name: 'Spain', iso2: 'ES', dial: '+34', flag: '🇪🇸' },
  { name: 'Italy', iso2: 'IT', dial: '+39', flag: '🇮🇹' },
  { name: 'Netherlands', iso2: 'NL', dial: '+31', flag: '🇳🇱' },
  { name: 'Portugal', iso2: 'PT', dial: '+351', flag: '🇵🇹' },
  { name: 'Belgium', iso2: 'BE', dial: '+32', flag: '🇧🇪' },
  { name: 'Switzerland', iso2: 'CH', dial: '+41', flag: '🇨🇭' },
  { name: 'Sweden', iso2: 'SE', dial: '+46', flag: '🇸🇪' },
  { name: 'Norway', iso2: 'NO', dial: '+47', flag: '🇳🇴' },
  { name: 'Denmark', iso2: 'DK', dial: '+45', flag: '🇩🇰' },
  { name: 'Poland', iso2: 'PL', dial: '+48', flag: '🇵🇱' },
  { name: 'United Arab Emirates', iso2: 'AE', dial: '+971', flag: '🇦🇪' },
  { name: 'Saudi Arabia', iso2: 'SA', dial: '+966', flag: '🇸🇦' },
  { name: 'Qatar', iso2: 'QA', dial: '+974', flag: '🇶🇦' },
  { name: 'India', iso2: 'IN', dial: '+91', flag: '🇮🇳' },
  { name: 'Pakistan', iso2: 'PK', dial: '+92', flag: '🇵🇰' },
  { name: 'China', iso2: 'CN', dial: '+86', flag: '🇨🇳' },
  { name: 'Japan', iso2: 'JP', dial: '+81', flag: '🇯🇵' },
  { name: 'South Korea', iso2: 'KR', dial: '+82', flag: '🇰🇷' },
  { name: 'Singapore', iso2: 'SG', dial: '+65', flag: '🇸🇬' },
  { name: 'Malaysia', iso2: 'MY', dial: '+60', flag: '🇲🇾' },
  { name: 'Indonesia', iso2: 'ID', dial: '+62', flag: '🇮🇩' },
  { name: 'Philippines', iso2: 'PH', dial: '+63', flag: '🇵🇭' },
  { name: 'Australia', iso2: 'AU', dial: '+61', flag: '🇦🇺' },
  { name: 'New Zealand', iso2: 'NZ', dial: '+64', flag: '🇳🇿' },
  { name: 'Brazil', iso2: 'BR', dial: '+55', flag: '🇧🇷' },
  { name: 'Mexico', iso2: 'MX', dial: '+52', flag: '🇲🇽' },
  { name: 'Argentina', iso2: 'AR', dial: '+54', flag: '🇦🇷' },
  { name: 'Turkey', iso2: 'TR', dial: '+90', flag: '🇹🇷' },
  { name: 'Israel', iso2: 'IL', dial: '+972', flag: '🇮🇱' },
];

export const DEFAULT_COUNTRY = COUNTRY_PHONE_CODES[0]; // Nigeria
